import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/mercari-prohibited-items';

export default function Example() {
  return (
    <>
      <Head>
        <title>Prohibited Mercari Items - Items that will get you banned from Mercari</title>
        <meta
          name='description'
          content="Don't get caught selling these items on Mercari! Mercari sellers are prohibited from offering certain items on the service. Learn more about these prohibited items!"
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/mercari-prohibited-items' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/mercari-prohibited-items' />
        <meta property='og:title' content='Prohibited Mercari Items - Items that will get you banned from Mercari' />
        <meta
          property='og:description'
          content="Don't get caught selling these items on Mercari! Mercari sellers are prohibited from offering certain items on the service. Learn more about these prohibited items!"
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-09-19T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-09-19T00:00:00.000Z' />
        <meta property='article:tag' content='Mercari' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
